import {Form, Input, Select, Slider, Typography} from "antd";
import React from "react";
const { Option } = Select;
const { Text, Title } = Typography;



const FormTitle = ({title})=>{
    return (
        <div className={'mb-3'}>
            <Title level={5} style={{fontWeight: '600'}}>{title}</Title>
        </div>
    )
}


export const portfolioNameInput = ()=>{
    return (
        <Form.Item
            name="name"
            label={<FormTitle title={'Portfolio Name'} />}
            rules={[{ required: true, message: 'Name is required' }]}
        >
            <Input size={'large'} />
        </Form.Item>
    )
}


export const portfolioDescription = ()=>{
    return (
        <Form.Item name={['attr', 'summary']} label={<FormTitle title={'Portfolio Description'} />}>
            <Input.TextArea size={'large'} autoSize={{minRows: 6}} className={'bordered dropped-shadow-hover round-2'} />
        </Form.Item>
    )
}


export const portfolioUseCase = ()=>{
    return (
        <Form.Item name={['attr', 'use_case']}  label={<FormTitle title={'Use Cases'} />}>
            <Input.TextArea size={'large'} autoSize={{minRows: 6}} className={'bordered dropped-shadow-hover round-2'} />
        </Form.Item>
    )
}

export const benchmarkInput = ()=>{
    return (
        <Form.Item
            name="benchmark"
            label={<FormTitle title={'Benchmark'} />}
        >
            <Input size={'large'} />
        </Form.Item>
    )
}

export const targetAllocationSlider = ({equityAllocation, onSliderChange})=>{
    return (
        <Form.Item label={<FormTitle title={'Target Allocations'} />}>
            <Slider
              marks={{ 0: '0%', 100: '100%' }}
              step={5}
              value={equityAllocation}
              onChange={onSliderChange}
              tooltipVisible
            />
            <div style={{ marginTop: 16 }}>
              Equity: {equityAllocation}%, Fixed Income: {equityAllocation===100?0:100-equityAllocation}%
            </div>
        </Form.Item>
    )
}






export const objectiveSelect = ()=>{
    return (
        <Form.Item
            name={['user_tags', 'objective']}
            label={<FormTitle title={'Objective'} />}
          >
            <Select size={'large'}>
                <Option value="model">Model Portfolio</Option>
                <Option value="growth_tilt">Growth Tilt</Option>
                <Option value="value_tilt">Value Tilt</Option>
                <Option value="dividend">Dividend Income</Option>
                <Option value="low_vol">Low Volatility</Option>
                <Option value="thematic">Thematic</Option>
            </Select>
        </Form.Item>
    )
}




